import { createContext, useContext } from 'react'

const TamarraParityContext = createContext(false)

export const TamarraParityProvider = ({ children, value = true }) => (
  <TamarraParityContext.Provider value={value}>{children}</TamarraParityContext.Provider>
)

export const useTamarraParity = () => useContext(TamarraParityContext)

export default TamarraParityContext
